<template>
  <b-dropdown
    ref="dropdown"
    @active-change="
      active => {
        show = active;
      }
    "
  >
    <button class="button" slot="trigger">
      <span>{{$tc('search.comments')}}</span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <div class="dropdown-item" style="width: 350px;" v-if="show">
      <form @submit.prevent="onSubmit">
        <button class="button is-primary">
          <b-icon icon="magnify"></b-icon>
          <span>{{$tc('search.search')}}</span>
        </button>
      </form>
    </div>
  </b-dropdown>
</template>

<script>
import BaseForm from "../../../../../components/BaseFilterForm";

export default {
  components: {},

  mixins: [BaseForm],

  methods: {
    fresh() {
      return {
        status: null
      };
    }
  }
};
</script>
